export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref6753.c98afcd6.jpg";